document.addEventListener('DOMContentLoaded', function () {
    const slides = document.querySelectorAll('.new-slideshow-item-slider');
    const dots = document.querySelectorAll('.slider-nav-dot');
    const autoplayDuration = parseInt(document.querySelector('.new-slideshow').getAttribute('data-autoplay')) || 3000;
    let currentSlide = 0;

        function showSlide(index) {
          slides.forEach((slide, idx) => {
            slide.classList.remove('active');
            dots[idx].classList.remove('active');
          });
          slides[index].classList.add('active');
          dots[index].classList.add('active');
        }

        function autoplay() {
          currentSlide = (currentSlide + 1) % slides.length;
          showSlide(currentSlide);
        }

        dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            currentSlide = index;
            showSlide(currentSlide);
          });
        });

        showSlide(currentSlide);

        setInterval(autoplay, autoplayDuration);
  });